export default __webpack_public_path__ + "static/media/right-chevron-icon.c1e1babc.svg";